import React from 'react';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { stringToFunction } from '@/pages/dashboard/utils/stringToJson';
import { useParams } from 'umi';

export default function StudioAssessmentCommonService(props: any) {
  const {
    style,
    className,
    api,
    dataKey = 'commonData',
    filterValue,
    filterLoading,
    gameCode,
    studioCode,
    extraParams,
    children,
    formatData,
    ...restProps
  } = props || {};

  const { studioId } = useParams() || ({} as any);

  const formatDataFunc = (data: any) => {
    if (formatData) return stringToFunction(formatData)(data);
    return data;
  };

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        formatData={formatDataFunc}
        data={{ ...props.data }}
        dataKey={dataKey}
        filterVal={filterValue}
        filterLoading={filterLoading}
        trackData={["gameCode","studioCode"]}
        beforeRequest={(data) => {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const { filterVal: { competitors } } = data;
          const productList = competitors?.map((item) => {
            return {
              studio: item?.studio,
              version: item?.version,
            };
          }) || [];

          const params = {
            studio_version_list: extraParams?.isRiskLevelInterface ? [productList[0] || {}] : productList,
            studio_code: studioId,
          };
          return params;
        }}
      >
        {React.Children.map(children, (child: any) => React.cloneElement(
          child,
          {
            ...(restProps || {}),
            gameCode,
            studioCode,
            filterValue,
            filterLoading,
          }
        ))}
      </Service>
    </div>
  );
};
